import { gql } from '@apollo/client';

export const SUBMIT_BATCH_ADJUSTMENT = gql`
    mutation SubmitBatchAdjustment($csvContentBase64: String!, $submitter: String!) {
        submitBatchAdjustment(csvContentBase64: $csvContentBase64, submitter: $submitter)
    }
`;
